import { render, staticRenderFns } from "./DcsMoreDialog.vue?vue&type=template&id=e82239b0"
import script from "./DcsMoreDialog.vue?vue&type=script&lang=ts"
export * from "./DcsMoreDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports